import Axios from "axios";
import Authorization from './auth';
import { API } from '../constants/urls';
import crudder from './crudder';
import profile from './profile';
import stripeClients from './stripeClients';
import appointments from './appointments';
import conversations from './conversations';
import messages from './messages';
import notifications from './notifications';
import authCrudder from './auth-crud';
import stripeTherapist from './stripeTherapist';
import requiredDocumentation from './requiredDocumentation';
import documentation from './documentation';
import admin from './admin';
import business from './business';
import wellness from './wellness';
import nom035, { businessNom035 } from './nom035';
import ai from './ai';
import payments from './payments';

export async function registerPush(data) {
    try {
        const response = await Axios.post(API + '/menu/user/pushregister', data, {
            headers: Authorization(),
        });

        return response.data;
    } catch (error) {
        console.error('ERROR on REGISTER PUSH ', error);
        throw error;
    }
}

const Crudder = crudder(API);
export const authAPI = authCrudder(API, "auth");
export const profileAPI = profile(API, "profile");
export const therapistAPI = Crudder("therapist");
export const categoriesAPI = Crudder("categories");
export const stripeClientsAPI = stripeClients(API, "stripe-clients");
export const stripeTherapistAPI = stripeTherapist(API, "stripe-therapist");
export const appointmentsAPI = appointments(API, "appointments");
export const conversationsAPI = conversations(API, "conversations");
export const messagesAPI = messages(API, "messages");
export const notificationsAPI = notifications(API, "notifications");
export const requiredDocumentationAPI = requiredDocumentation(API, "required-documentation");
export const documentationAPI = documentation(API, "documentation");
export const adminAPI = admin(API, "admin");
export const businessAPI = business(API, "business");
export const wellnessAPI = wellness(API, "wellness");
export const nom035API = nom035(API, "nom035");
export const businessNom035API = businessNom035(API, "business/nom035");
export const aiAPI = ai(API, "ai");
export const paymentsAPI = payments(API, "payments");

// Announcements / MOTD
const getHeaders = () => Authorization();
export const announcementsAPI = {
    getAll:  () => Axios.get(`${API}/announcements`,          { headers: getHeaders() }).then(r => r.data?.data ?? []),
    adminGetAll: () => Axios.get(`${API}/admin/announcements`,{ headers: getHeaders() }).then(r => r.data?.data ?? []),
    adminCreate: (data) => Axios.post(`${API}/admin/announcements`, data, { headers: getHeaders() }).then(r => r.data?.data),
    adminUpdate: (id, data) => Axios.patch(`${API}/admin/announcements/${id}`, data, { headers: getHeaders() }).then(r => r.data?.data),
    adminDelete: (id) => Axios.delete(`${API}/admin/announcements/${id}`, { headers: getHeaders() }),
};
